module.exports = __webpack_public_path__ + "img/checkmark.e3de8659.png";